var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v("Olá! Vamos realizar a validação das responsabilidades?"),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Competências")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na aba COMPETÊNCIAS você pode selecionar a(s) subunidade(s) hierarquicamente vinculada(s) a sua e visualizar o rol de competências técnicas (gerais ou inseridas) necessárias para realizar uma responsabilidade. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Responsabilidades")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na aba RESPONSABILIDADES você pode selecionar a(s) subunidade(s) hierarquicamente vinculada(s) a sua e visualizar as informações sobre: responsabilidade, impacto, dificuldade e competências técnicas. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [_vm._v(" Recomenda-se visualizar uma subunidade por vez. ")]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Validação de responsabilidades")]),
      _c(
        "p",
        { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
        [
          _vm._v(
            " Antes de validar cada responsabilidade de uma subunidade, pergunte-se: "
          ),
        ]
      ),
      _c(
        "p",
        {
          staticClass:
            "mx-2 pa-2 text-center info--text font-weight-medium text-lg-h6",
        },
        [
          _vm._v(
            " Essa responsabilidade contribui para a realização da missão da unidade? "
          ),
        ]
      ),
      _c(
        "p",
        { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
        [
          _vm._v(
            " Se a resposta for “sim”, tem-se uma responsabilidade, se for “não”, é apenas uma tarefa e não precisa ser validada, ou merece ser reformulada. "
          ),
        ]
      ),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v("Níveis de impacto, dificuldade e competências técnicas"),
      ]),
      _c(
        "p",
        { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
        [
          _vm._v(
            " Durante a etapa de validação das responsabilidades você pode alterar o nível de impacto e de dificuldade para a realização de cada uma, além de incluir ou excluir competências técnicas necessárias para sua execução. "
          ),
        ]
      ),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-6 pa-4 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Verifique se a responsabilidade descreve “o que fazer” e não o “como fazer” "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Observe se o verbo encontra-se no "),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("infinitivo"),
                ]),
                _vm._v(" + contextualização "),
              ]
            ),
            _c(
              "p",
              { staticClass: "text-start font-weight-medium text-lg-h6" },
              [
                _vm._v(" Exemplo 1: "),
                _c("span", { staticClass: "error--text" }, [
                  _vm._v("Convocar"),
                ]),
                _c("span", { staticClass: "info--text" }, [
                  _vm._v(
                    "candidatos aprovados em concurso público para cargos efetivos."
                  ),
                ]),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Cada servidor lotado na unidade deve executar no mínimo 1 (uma) das responsabilidades descritas, por isso, recomenda-se realizar a validação do mapeamento técnico em conjunto com a chefia da unidade. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }